    import React, { useState, useEffect } from 'react';
import './App.css';
import { FaHome, FaCalendarAlt, FaEnvelopeOpenText, FaBars, FaMusic, FaClock, FaPhone } from 'react-icons/fa';
import { motion } from 'framer-motion';

const WeddingWebsite = () => {
  const [activeTab, setActiveTab] = useState('startseite');
  const [menuOpen, setMenuOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const tabs = [
    { name: 'startseite', icon: <FaHome /> },
    { name: 'ablaufplan', icon: <FaCalendarAlt /> },
    { name: 'musikwünsche', icon: <FaMusic /> },
    { name: 'übernachtung & location', icon: <FaClock /> },
    { name: 'zeitkapsel', icon: <FaEnvelopeOpenText /> },
    { name: 'ansprechpartner', icon: <FaPhone /> }
  ];

  useEffect(() => {
    const savedPassword = localStorage.getItem('weddingPassword');
    if (savedPassword === 'Winter') {
      setIsAuthenticated(true);
    }
    window.scrollTo(0, 0);

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    document.body.classList.toggle('menu-open', !menuOpen); // Fix: Toggle correctly
  };

  const checkPassword = () => {
    const correctPassword = "Winter";
    if (passwordInput === correctPassword) {
      localStorage.setItem('weddingPassword', passwordInput);
      setIsAuthenticated(true);
    } else {
      alert("Falsches Passwort. Bitte versuche es erneut.");
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="password-protect" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'Poppins, sans-serif', backgroundColor: '#f0f5f0', padding: '20px' }}>
        <h1 style={{ color: '#2b7a2b', marginBottom: '30px', fontSize: '2.5rem' }}>Passwort bitte:</h1>
        <input
          type="password"
          placeholder="Passwort eingeben"
          value={passwordInput}
          onChange={(e) => setPasswordInput(e.target.value)}
          className="form-input"
          style={{ padding: '12px', marginBottom: '20px', width: '80%', maxWidth: '400px', borderRadius: '8px', border: '1px solid #2b7a2b', fontSize: '1rem' }}
        />
        <button className="send-button" onClick={checkPassword} style={{ padding: '10px 20px', backgroundColor: '#2b7a2b', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', transition: 'background-color 0.3s' }}>
          Bestätigen
        </button>
      </div>
    );
  }

  return (
    <div className="container" style={{ backgroundImage: `url('/background.jpg')`, backgroundSize: 'cover', backgroundPosition: 'center', minHeight: '100vh', padding: '20px', borderRadius: '15px' }}>
      <div className="header-image-container">
        <img src="/name.jpg" alt="Eukalyptus" className="header-image-full" style={{ maxWidth: '500px', borderRadius: '15px', marginBottom: '20px' }} />
      </div>

      {isMobile && (
        <div className="mobile-menu-icon" onClick={toggleMenu}>
          <FaBars />
        </div>
      )}

      <div className={`tabs ${menuOpen ? 'open' : ''}`} style={{ flexDirection: isMobile ? 'column' : 'row', marginTop: '20px' }}>
        {tabs.map(tab => (
          <motion.button
            key={tab.name}
            onClick={() => {
              setActiveTab(tab.name);
              if (isMobile) toggleMenu();
              window.scrollTo(0, 0);
            }}
            className={`tab-button ${activeTab === tab.name ? 'active' : ''}`}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            style={{ padding: '10px 20px', margin: '5px', borderRadius: '8px', backgroundColor: activeTab === tab.name ? '#2b7a2b' : 'white', color: activeTab === tab.name ? 'white' : '#2b7a2b', border: '1px solid #2b7a2b' }}
          >
            {tab.icon} {tab.name.charAt(0).toUpperCase() + tab.name.slice(1)}
          </motion.button>
        ))}
      </div>

      <div className="content"> {/* Content Container corrected */}
        {activeTab === 'startseite' && (
          <div>
            <p>Liebe Familie und Freunde,</p>
            <p>Wir freuen uns riesig, euch zu unserer Hochzeit am 12. Juli 2025 einladen zu dürfen!</p>
            <p>Hier findet ihr alle wichtigen Informationen zu unserem großen Tag.</p>
          </div>
        )}
        {activeTab === 'ablaufplan' && (
          <div>
            <h2>Ablaufplan - grob 😉</h2>
            <p><strong>Ankunft:</strong> 13:00 Uhr</p>
            <p><strong>Trauung:</strong> 13:30 Uhr</p>
            <p>Anschließend Sektempfang & Gratulation & Check-In</p>
            <p><strong>Kaffee & Kuchen:</strong> 15:30 Uhr</p>
            <p><strong>Abendessen:</strong> 19:00 Uhr</p>
            <p><strong>Mitternachtssnack:</strong> 0:00 Uhr</p>
          </div>
        )}

{activeTab === 'musikwünsche' && (
  <div>
    <h2>Musikwünsche</h2>
    <p>
      Habt ihr einen Song, den ihr unbedingt hören möchtet? 🎶<br />
      Ladet ihn doch einfach in unsere spezielle Spotify-Playlist hoch!<br />
      Lasst uns gemeinsam für die perfekte Stimmung sorgen!
    </p>
    <a 
      href="https://open.spotify.com/playlist/3fS7FV04eCVNiGcOw9FFMp?si=usv5bXs_SCGdjSP7OW2KTQ&pt=69f4f11088afb358b830a8e1d02d14fa&pi=9g0Lx0UQSNaB_"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-block',
        marginTop: '1rem',
        padding: '0.75rem 1.5rem',
        backgroundColor: '#1DB954', // Spotify-Grün
        color: 'white',
        textDecoration: 'none',
        borderRadius: '8px',
        fontWeight: 'bold',
        fontSize: '1rem',
        transition: 'background-color 0.3s ease'
      }}
      onMouseOver={(e) => e.target.style.backgroundColor = '#17a44c'}
      onMouseOut={(e) => e.target.style.backgroundColor = '#1DB954'}
    >
      🎵 Musikwünsche eintragen
    </a>
  </div>
)}



        {activeTab === 'übernachtung & location' && (
          <div>
            <h2>Übernachtung & Location</h2>
            <p>Für jeden Gast ist ein Zimmer bei unserer Location reserviert.</p>
            <p>Wir bitten euch darum, uns die Kosten für die Übernachtung zu überweisen, Bar zu geben oder per Paypal zu senden.</p>
            <p>Über die konkrete Höhe der Kosten werden wir euch zeitnah informieren.</p>
            <p>Konotinhaber: Tristan Winter</p>
            <p>IBAN: DE98 5001 0517 5416 8751 61</p>
            <p>Die Adresse der Location lautet:</p>
            <p><a href="https://www.google.com/maps?q=Naturresort+Bieleboh,+Bielebohstraße+18,+02736+Beiersdorf" target="_blank">Naturresort Bieleboh, Bielebohstraße 18, 02736 Beiersdorf</a></p>
          </div>
        )}

        {activeTab === 'zeitkapsel' && (
          <div>
            <h2>Zeitkapsel</h2>
            <p>Wir möchten mit euch eine besondere Erinnerung schaffen: Eine Zeitkapsel! 🕰️<br/>Bringt bitte einen Gegenstand mit, der euch mit uns verbindet. Wir werden all diese Dinge nach der Hochzeit eingraben und in 10, 20 oder 30 Jahren wieder ausgraben. 🌱✨</p>
          </div>
        )}

        {activeTab === 'ansprechpartner' && (
          <div>
            <h2>Ansprechpartner</h2>
            <p>Hier sind unsere Trauzeugen, die euch gerne bei Fragen weiterhelfen:</p>
            <p><strong>Ticia Wildenhayn:</strong> +49 152 37102232</p>
            <p><strong>Raphael Renz:</strong> +49 152 29444567</p>
            <p><strong>Max Böhme:</strong> +49 172 3207559</p>
            <p>Wenn ihr Beiträge planen möchtet, sprecht euch dazu bitte mit unseren Trauzeugen ab.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default WeddingWebsite;
